import React from 'react';

function MarkerIcon({ size = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 17"
    >
      <g fill="#000" clipPath="url(#clip0_4236_2350)">
        <path d="M8 4.826a2.667 2.667 0 100 5.334 2.667 2.667 0 000-5.334zm0 4A1.333 1.333 0 118 6.16a1.333 1.333 0 010 2.667z"></path>
        <path d="M8 16.826a3.515 3.515 0 01-2.874-1.466c-2.54-3.505-3.83-6.14-3.83-7.831a6.703 6.703 0 1113.408 0c0 1.692-1.29 4.326-3.83 7.83A3.515 3.515 0 018 16.827zM8 2.281A5.255 5.255 0 002.75 7.53c0 1.34 1.263 3.818 3.554 6.977a2.097 2.097 0 003.393 0c2.29-3.16 3.553-5.637 3.553-6.977A5.255 5.255 0 008 2.28z"></path>
      </g>
      <defs>
        <clipPath id="clip0_4236_2350">
          <path fill="#fff" d="M0 0H16V16H0z" transform="translate(0 .826)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default MarkerIcon;
